<template>
  <div v-if="book">
    <BookShow :book="book"></BookShow>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BookShow from "@/components/Library/BookShow";

export default {
  components: {
    BookShow
  },
  methods: {
    ...mapActions("library", ["fetchBook"])
  },
  computed: {
    ...mapState("library", ["book"])
  },
  mounted() {
    let bookId = this.$route.params.id;
    this.fetchBook(bookId);
  }
};
</script>